export const BUYBACK_MAX_WEIGHT = 40.0;
export const BUYBACK_MIN_OFFER_PRICE = 7.0;
export const DEFAULT_FREE_SHIPPING_THRESHOLD = 20;

export enum SnowplowSchemas {
  AB_TEST_ACTION = "iglu:com.thriftbooks/ab_test_action/jsonschema/1-0-1",
  RECOMMENDED_WORK = "iglu:com.thriftbooks/recommended_work/jsonschema/2-0-0",
  RECOMMENDATION_SHOWN = "iglu:com.thriftbooks/recommendation_shown/jsonschema/3-0-0",
  CART_ITEM_INTERACTION = "iglu:com.thriftbooks/cart_item_interaction/jsonschema/1-0-1",
  LIST_ITEM_INTERACTION = "iglu:com.thriftbooks/list_item_interaction/jsonschema/1-0-1",
}

export const HomepageVNextRolloutTest = Object.freeze({
  TestName: "HomepageVNextRollout",
  HomepageViewedActionName: "Homepage viewed",
  HomepageViewedEventId: 0,
});

export const WorksPageVNextRolloutTest = Object.freeze({
  TestName: "WorksPageVNextRollout",
  WorksPageViewedActionName: "Works page viewed",
  WorksPageViewedEventId: 0,
});
